<button
  matButton
  class="primary-button"
  (click)="goBack()">
  <mat-icon>chevron_left</mat-icon>
  <span>Back</span>
</button>

@if (state.error()) {
  <div
    role="alert"
    class="profile-state">
    <p>The entity details could not be loaded.</p>
    <button
      matButton="outlined"
      type="button"
      class="primary-button"
      (click)="state.reload()">
      Retry
    </button>
  </div>
} @else if (profile(); as publicProfile) {
  <article class="article">
    <header class="company-header">
      <div class="header-top">
        <div class="head-left">
          <h1>Entity details</h1>
        </div>

        <div class="head-right">
          @if (publicProfile.logicalStatus === logicalStatus.UPDATING) {
            <button
              matButton="outlined"
              class="primary-button m-r-half"
              umeDisableUntilResolve
              [loadingState]="disableBtn$"
              [disabled]="state.isBusy()"
              (click)="undo()">
              @if (state.isUndoing()) {
                <mat-icon
                  fontSet="material-symbols-outlined"
                  class="rotating">
                  refresh
                </mat-icon>
              } @else {
                <mat-icon>history</mat-icon>
              }
              Discard draft changes
            </button>
          }

          @if (publicProfile.logicalStatus === logicalStatus.VALIDATED) {
            <div class="flex flex-gap-half align-center">
              <mat-icon class="green">check</mat-icon>
              <p>All information is up to date.</p>
              <button
                matButton="filled"
                class="primary-button"
                umeDisableUntilResolve
                [loadingState]="disableBtn$"
                (click)="edit()">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
            </div>
          } @else {
            <div
              [matTooltip]="!isFormValid() ? 'Please complete all required fields to submit.' : ''">
              <button
                matButton="filled"
                class="primary-button"
                umeDisableUntilResolve
                [loadingState]="disableBtn$"
                [disabled]="!isFormValid() || state.isBusy()"
                (click)="validate()">
                @if (state.isSubmitting()) {
                  <mat-icon
                    fontSet="material-symbols-outlined"
                    class="rotating">
                    refresh
                  </mat-icon>
                } @else {
                  <mat-icon>ios_share</mat-icon>
                }
                Submit entity details
              </button>
            </div>
          }
        </div>
      </div>
    </header>

    <main>
      <div class="content">
        <form
          [formGroup]="form"
          class="company-form">
          <section class="vp-company-info">
            <!-- Logo -->
            <div class="logo-cell">
              <ume-upload-logo-component
                [displayedLogo]="displayedLogo()"
                [title]="'Logo'"
                [companyName]="publicProfile.identity.companyName"
                (clearLogo)="clearLogo()"
                (uploadImage)="uploadImageDialog()"></ume-upload-logo-component>
            </div>

            <!-- Fields -->
            <div class="fields-cell">
              <ume-entity-name-input
                [fieldAppearance]="'outline'"
                [fitShape]="true"
                [noLabel]="false"
                [noSubWrapper]="false"
                [isShowLEISearch]="false"
                [country]="publicProfile.identity.country"
                [formControlName]="fields.NAME"
                (selectedFromLeiProfile)="selectLei($event)"></ume-entity-name-input>

              <mat-form-field
                appearance="outline"
                class="full-width">
                <mat-label>About the entity</mat-label>
                <textarea
                  matInput
                  rows="5"
                  placeholder="Start typing here."
                  [formControlName]="fields.ABOUT"></textarea>
              </mat-form-field>
            </div>
          </section>
        </form>
      </div>
    </main>
  </article>
} @else {
  <div class="profile-state">
    <ume-loader [size]="1"></ume-loader>
  </div>
}
